import { CustomerTeam, StaffCustomers } from '../actions/index';
import { ORGANISATION_CONTEXT_SWITCH } from '../actions/meta.actions';
import { DataListState } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';
import { CustomerDto } from '@careapp-group/ng-sdk';

class StaffCustomersReducer extends ReducerStateFactory<CustomerDto> {
  constructor() {
    super(StaffCustomers);
  }

  reducer(
    state: DataListState<CustomerDto> = this.initialState,
    action: any
  ): DataListState<CustomerDto> {
    switch (action.type) {
      case ORGANISATION_CONTEXT_SWITCH:
        return { ...state, entities: {}, ids: [], selectedId: null };
      case StaffCustomers.RESPONSE_SUCCESS_REMOVE:
        const ids = Array.from(
          new Set(state.ids.filter((value) => value != action.payload.customerId))
        );
        const entities = ids.reduce(
          (prev, next) => ({ ...prev, [next]: state.entities[next] }),
          {}
        );
        return {
          ...state,
          loadingAll: false,
          ids,
          entities,
        };
      case CustomerTeam.ResponseSuccessRemove.type: {
        const ids = Array.from(new Set(state.ids.filter((value) => value != action.customerId)));
        const entities = ids.reduce(
          (prev, next) => ({ ...prev, [next]: state.entities[next] }),
          {}
        );
        return {
          ...state,
          loadingAll: false,
          ids,
          entities,
        };
      }
    }
    return super.reducer(state, action);
  }
}

export const state = new StaffCustomersReducer();

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
